import React, { useState, useEffect } from "react";
import AppInfo from "../AppInfo";
import { auth } from "./firebase";

const Debug = () => {
    const [userId, setUserId] = useState("Loading...");

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setUserId(user ? user.uid : "Not logged in");
        });
        return () => unsubscribe();
    }, []);

    const copyText = () => {
        const text = `version: ${AppInfo.version}\nuserId: ${userId}`;
        navigator.clipboard.writeText(text).then(() => {
            alert("Text copied to clipboard");
        }).catch(err => {
            console.error("Failed to copy text: ", err);
        });
    };

    return (
        <div>
            version: {AppInfo.version}
            <br />
            userId: {userId}
            <br />
            <button onClick={copyText}>Copy Text</button>
        </div>
    );
};

export default Debug;